import React, { Component } from "react";
import Appointment from "../common/Appointment";
import AppointmentCard from "../common/Appointment_card";
import Select from "../common/Select";
import { Route, Router, useParams, useLocation } from "react-router-dom";
import { createBrowserHistory, createHashHistory } from "history";
import BookingDetails from "./Booking-details";
import { StatsContext } from "../contexts/StatsContext";
import { getDateData } from "../common/HelperFunctions";
import nobooking from "../assets/nobooking.svg";

const history = createBrowserHistory();
export default class Bookings extends Component {
  static contextType = StatsContext;
  state = {
    currentTab: 1,
  };

  componentDidMount() {
    // Refresh appointments when navigating to bookings page
    if (this.context.fetchAppointments) {
      this.context.fetchAppointments();
    }
  }

  render() {
    const { upcoming_bookings, past_bookings } = this.context;

    return (
      <div className="all-bookings">
        <div className="wrapper bookings section">
          <div className="section-header flex space-btw">
            <p className="section-title">Bookings</p>
            {/* <div className="co-pink link">See all bookings</div> */}

            <div className="filter flex">
              <div className="icon"></div>
              <Select
                onChange={({ currentTarget: { value } }) => {
                  this.setState({ currentTab: Number(value) });
                }}
              >
                <option value="1" defaultValue>
                  Upcoming
                </option>
                <option value="2">Past</option>
              </Select>
            </div>
          </div>

          {this.state.currentTab > 1
            ? Appointments(past_bookings, "Past")
            : Appointments(upcoming_bookings, "Upcoming")}
        </div>

        {/* convert to modal on desktop */}
        {window.innerWidth >= 600 ? (
          <Route path="/bookings/:id/booking" component={Booking_details} />
        ) : null}
      </div>
    );
  }
}

function Appointments(bookings, name) {
  return (
    <>
      {/* empty state */}
      {Object.keys({ ...bookings }).length <= 0 ? (
        <div className="emptyState">
          <img src={nobooking} alt="" />
          <p>
            {name} appointments show up here when a{" "}
            {name === "Past"
              ? "reservation's date is in the past"
              : "reservation is made for your service"}
          </p>
        </div>
      ) : (
        bookings && (
          <>
            {Object.keys({ ...bookings }).map((date, index) => (
              <Appointment
                key={index}
                {...getDateData(bookings[date][0].date)}
              >
                {bookings[date].map((booking, idx) => (
                  <AppointmentCard {...booking} key={idx} />
                ))}
              </Appointment>
            ))}
            <p className="end">End of list</p>
          </>
        )
      )}
    </>
  );
}

function Booking_details() {
  let { id } = useParams();
  let location = useLocation();
  return <BookingDetails id={id} location={location} />;
}
